import type { ApiPreset } from "./types";

export enum ICON_IDS {
  AMBIENT = "ambient",
  ANIMALS = "animals",
  CUSTOM = "custom",
  DEFAULT = "default",
  DRUMS = "drums",
  MOVIE = "movie",
}

export const DEFAULT_ICONS = {
  [ICON_IDS.AMBIENT]:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-preset-icons/rain.svg",
  [ICON_IDS.DRUMS]:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-preset-icons/drums.svg",
  [ICON_IDS.MOVIE]:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-preset-icons/branches.svg",
  [ICON_IDS.ANIMALS]:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-preset-icons/animals.svg",
  [ICON_IDS.CUSTOM]:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-preset-icons/custom.svg",
  [ICON_IDS.DEFAULT]:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-preset-icons/rain.svg",
};

export const DEFAULT_SOUND_URLS: Record<string, string> = {
  ambient_light_rain:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/soft_cosy_rain-%232-1756821290252.mp3",
  ambient_heavy_rain:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/heavy_rainfall_heard-%233-1756821421546.mp3",
  ambient_waves:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/sound_of_waves_as_he-%232-1756821054778.mp3",
  ambient_trickling_stream:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/water_trickling_in_a-%231-1756820862109.mp3",
  ambient_thunder:
    "https://storage.googleapis.com/eleven-public-cdn/audio/sound-effects-library/thunder/11L-thunder-14194833.mp3",
  ambient_wind:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/the_sound_of_wind_ru-1756821272513.mp3",
  ambient_wind_whooshing_trees:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/wind_whooshing_trees.mp3",
  ambient_fire:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/crackle_of_a_firepla-1756821379423.mp3",
  ambient_coffee_shop:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/coffee_shop_backgrou.mp3",
  ambient_forest:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/forest.mp3",
  ambient_crickets:
    "https://storage.googleapis.com/eleven-public-cdn/audio/sound-effects-library/cricket/11L-crickets-89122931.mp3",
  ambient_white_noise:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient_sound_white_.mp3",
  ambient_singing_bowl:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/singingbowl.mp3",
  ambient_birdsong_1:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/bird_song_in_a_fores-%232-1756821500245.mp3",
  ambient_birdsong_2:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/ambient/birdsong-1756821516975.mp3",
  ambient_birdsong_3:
    "https://storage.googleapis.com/eleven-public-cdn/audio/sound-effects-library/birdsong/11L-birdsong-38762596.mp3",
  drums_kick:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_kick_drum_short.mp3",
  drums_kick_2:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_kick_drum_2.mp3",
  drums_snare:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_snare_drum_1.mp3",
  drums_snare_2:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_snare_drum_2.mp3",
  drums_high_tom:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_high_tom_1.mp3",
  drums_mid_tom:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_mid_tom_1.mp3",
  drums_low_tom:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_low_tom_1.mp3",
  drums_floor_tom:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/single_low_floor_tom.mp3",
  drums_hi_hat_closed:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/closed_hi_hat.mp3",
  drums_hi_hat_open:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/hi-hat-open.mp3",
  drums_hi_hat_foot:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/hi-hat-foot-pedal.mp3",
  drums_ride_cymbal:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/ride-cymbal-1.mp3",
  drums_ride_cymbal_2:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/ride-cymbal-2.mp3",
  drums_crash_1:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/crash-2.mp3",
  drums_crash_2:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/crash-2.mp3",
  drums_cowbell:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/drums-preset/cowbell.mp3",
  movie_explosion_1:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/a_huge_movie_explosi.mp3",
  movie_explosion_2:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/a_huge_movie_explosi-2.mp3",
  movie_gunshot_1:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/A_movie_gunshot_soun.mp3",
  movie_gunshot_2:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/A_movie_gunshot_soun-2.mp3",
  laugh_track:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/a_sitcom_laugh_track.mp3",
  audience_gasp:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/audience_gasping%2C_li.mp3",
  woman_scream:
    "https://storage.googleapis.com/eleven-public-cdn/audio/sound-effects-library/woman-screaming/11L-woman_screaming_distant-74374633.mp3",
  impact:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/a_movie_impact_sound.mp3",
  siren: "https://storage.googleapis.com/eleven-public-cdn/audio/sound-effects-library/siren/11L-siren-24542005.mp3",
  animal_cat_meow:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/Cat_meow.mp3",
  animal_dog_bark:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/Dog_bark.mp3",
  animal_birdsong_1:
    "https://storage.googleapis.com/eleven-public-cdn/audio/sound-effects-library/birdsong/11L-birdsong-38762596.mp3",
  animal_birdsong_2:
    "https://storage.googleapis.com/eleven-public-cdn/audio/sound-effects-library/birdsong/11L-birdsong_ambience_park-76156611.mp3",
  animal_rooster:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/rooster.mp3",
  animal_monkey:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/monkey.mp3",
  animal_lion:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/lion_roaring.mp3",
  animal_elephant:
    "https://storage.googleapis.com/eleven-public-cdn/marketing_website/assets/soundboard-audio/elephant.mp3",
} as const;

// Sample presets with sounds from various free sources
export const SAMPLE_PRESETS: ApiPreset[] = [
  {
    name: "Ambient",
    icon: DEFAULT_ICONS[ICON_IDS.AMBIENT],
    sounds: [
      {
        defaultSoundId: "ambient_light_rain",
        name: "Light Rain",
        url: DEFAULT_SOUND_URLS["ambient_light_rain"],
      },
      {
        defaultSoundId: "ambient_heavy_rain",
        name: "Heavy Rain",
        url: DEFAULT_SOUND_URLS["ambient_heavy_rain"],
      },
      {
        defaultSoundId: "ambient_waves",
        name: "Waves",
        url: DEFAULT_SOUND_URLS["ambient_waves"],
      },
      {
        defaultSoundId: "ambient_trickling_stream",
        name: "Trickling Stream",
        url: DEFAULT_SOUND_URLS["ambient_trickling_stream"],
      },
      {
        defaultSoundId: "ambient_thunder",
        name: "Thunder",
        url: DEFAULT_SOUND_URLS["ambient_thunder"],
      },
      {
        defaultSoundId: "ambient_wind",
        name: "Wind",
        url: DEFAULT_SOUND_URLS["ambient_wind"],
      },
      {
        defaultSoundId: "ambient_wind_whooshing_trees",
        name: "Wind in Trees",
        url: DEFAULT_SOUND_URLS["ambient_wind_whooshing_trees"],
      },
      {
        defaultSoundId: "ambient_fire",
        name: "Fire",
        url: DEFAULT_SOUND_URLS["ambient_fire"],
      },
      {
        defaultSoundId: "ambient_forest",
        name: "Forest",
        url: DEFAULT_SOUND_URLS["ambient_forest"],
      },
      {
        defaultSoundId: "ambient_birdsong_1",
        name: "Birds 1",
        url: DEFAULT_SOUND_URLS["ambient_birdsong_1"],
      },
      {
        defaultSoundId: "ambient_birdsong_2",
        name: "Birds 2",
        url: DEFAULT_SOUND_URLS["ambient_birdsong_2"],
      },
      {
        defaultSoundId: "ambient_crickets",
        name: "Crickets",
        url: DEFAULT_SOUND_URLS["ambient_crickets"],
      },
      {
        defaultSoundId: "ambient_white_noise",
        name: "White Noise",
        url: DEFAULT_SOUND_URLS["ambient_white_noise"],
      },
      {
        defaultSoundId: "ambient_singing_bowl",
        name: "Singing Bowl",
        url: DEFAULT_SOUND_URLS["ambient_singing_bowl"],
      },
    ],
  },
  {
    name: "Drums",
    icon: DEFAULT_ICONS[ICON_IDS.DRUMS],
    sounds: [
      {
        defaultSoundId: "drums_kick",
        name: "Kick 1",
        url: DEFAULT_SOUND_URLS["drums_kick"],
      },
      {
        defaultSoundId: "drums_kick_2",
        name: "Kick 2",
        url: DEFAULT_SOUND_URLS["drums_kick_2"],
      },
      {
        defaultSoundId: "drums_snare",
        name: "Snare 1",
        url: DEFAULT_SOUND_URLS["drums_snare"],
      },
      {
        defaultSoundId: "drums_snare_2",
        name: "Snare 2",
        url: DEFAULT_SOUND_URLS["drums_snare_2"],
      },
      {
        defaultSoundId: "drums_high_tom",
        name: "High Tom",
        url: DEFAULT_SOUND_URLS["drums_high_tom"],
      },
      {
        defaultSoundId: "drums_mid_tom",
        name: "Mid Tom",
        url: DEFAULT_SOUND_URLS["drums_mid_tom"],
      },
      {
        defaultSoundId: "drums_low_tom",
        name: "Low Tom",
        url: DEFAULT_SOUND_URLS["drums_low_tom"],
      },
      {
        defaultSoundId: "drums_floor_tom",
        name: "Floor Tom",
        url: DEFAULT_SOUND_URLS["drums_floor_tom"],
      },
      {
        defaultSoundId: "drums_hi_hat_closed",
        name: "Hi-hat closed",
        url: DEFAULT_SOUND_URLS["drums_hi_hat_closed"],
      },
      {
        defaultSoundId: "drums_hi_hat_open",
        name: "Hi-hat open",
        url: DEFAULT_SOUND_URLS["drums_hi_hat_open"],
      },
      {
        defaultSoundId: "drums_hi_hat_foot",
        name: "Hi-hat foot",
        url: DEFAULT_SOUND_URLS["drums_hi_hat_foot"],
      },
      {
        defaultSoundId: "drums_ride_cymbal",
        name: "Ride cymbal",
        url: DEFAULT_SOUND_URLS["drums_ride_cymbal"],
      },
      {
        defaultSoundId: "drums_ride_cymbal_2",
        name: "Ride cymbal 2",
        url: DEFAULT_SOUND_URLS["drums_ride_cymbal_2"],
      },
      {
        defaultSoundId: "drums_crash_1",
        name: "Crash 1",
        url: DEFAULT_SOUND_URLS["drums_crash_1"],
      },
      {
        defaultSoundId: "drums_crash_2",
        name: "Crash 2",
        url: DEFAULT_SOUND_URLS["drums_crash_2"],
      },
      {
        defaultSoundId: "drums_cowbell",
        name: "Cowbell",
        url: DEFAULT_SOUND_URLS["drums_cowbell"],
      },
    ],
  },
  {
    name: "Movie/TV",
    icon: DEFAULT_ICONS[ICON_IDS.MOVIE],
    sounds: [
      {
        defaultSoundId: "movie_explosion_1",
        name: "Explosion 1",
        url: DEFAULT_SOUND_URLS["movie_explosion_1"],
      },
      {
        defaultSoundId: "movie_explosion_2",
        name: "Explosion 2",
        url: DEFAULT_SOUND_URLS["movie_explosion_2"],
      },
      {
        defaultSoundId: "movie_gunshot_1",
        name: "Gunshot 1",
        url: DEFAULT_SOUND_URLS["movie_gunshot_1"],
      },
      {
        defaultSoundId: "movie_gunshot_2",
        name: "Gunshot 2",
        url: DEFAULT_SOUND_URLS["movie_gunshot_2"],
      },
      {
        defaultSoundId: "laugh_track",
        name: "Laugh track",
        url: DEFAULT_SOUND_URLS["laugh_track"],
      },
      {
        defaultSoundId: "audience_gasp",
        name: "Gasp (Audience)",
        url: DEFAULT_SOUND_URLS["audience_gasp"],
      },
      {
        defaultSoundId: "woman_scream",
        name: "Scream",
        url: DEFAULT_SOUND_URLS["woman_scream"],
      },
      {
        defaultSoundId: "impact",
        name: "Impact",
        url: DEFAULT_SOUND_URLS["impact"],
      },
      {
        defaultSoundId: "siren",
        name: "Siren",
        url: DEFAULT_SOUND_URLS["siren"],
      },
    ],
  },
  {
    name: "Animals",
    icon: DEFAULT_ICONS[ICON_IDS.ANIMALS],
    sounds: [
      {
        defaultSoundId: "animal_cat_meow",
        name: "Cat meow",
        url: DEFAULT_SOUND_URLS["animal_cat_meow"],
      },
      {
        defaultSoundId: "animal_dog_bark",
        name: "Dog bark",
        url: DEFAULT_SOUND_URLS["animal_dog_bark"],
      },
      {
        defaultSoundId: "animal_birdsong_1",
        name: "Birdsong 1",
        url: DEFAULT_SOUND_URLS["animal_birdsong_1"],
      },
      {
        defaultSoundId: "animal_birdsong_2",
        name: "Birdsong 2",
        url: DEFAULT_SOUND_URLS["animal_birdsong_2"],
      },
      {
        defaultSoundId: "animal_rooster",
        name: "Rooster",
        url: DEFAULT_SOUND_URLS["animal_rooster"],
      },
      {
        defaultSoundId: "animal_monkey",
        name: "Monkey",
        url: DEFAULT_SOUND_URLS["animal_monkey"],
      },
      {
        defaultSoundId: "animal_lion",
        name: "Lion",
        url: DEFAULT_SOUND_URLS["animal_lion"],
      },
      {
        defaultSoundId: "animal_elephant",
        name: "Elephant",
        url: DEFAULT_SOUND_URLS["animal_elephant"],
      },
    ],
  },
];
